<template>
  <v-container>
    <h5>
      <strong>{{ $t("name") }}:</strong> {{ title }}
      <span class="ml-5" v-if="supervisor"
      ><strong> Supervisor:</strong> {{ supervisor.username }}</span
      >
    </h5>
    <v-divider />
    <RejectCommentLayout :comment-text="reject_comment" />
    <v-layout row justify-center>
      <v-flex md12>
        <form class="padding-20">
          <v-row justify="center">
            <v-col cols="3">
              <v-select
                v-model="investigator.vacation.type"
                :items="vacations"
                label="Vacation Type"
                required
                outlined
                disabled
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                readonly
                v-model="numberDays"
                label="Number of days"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <h4 class="text-left">Start Date</h4>
              <v-date-picker
                full-width
                v-model="investigator.vacation.start_date"
                :locale="$store.state.language"
                disabled
              />
            </v-col>
            <v-col cols="4" />
            <v-col cols="4">
              <h4 class="text-left">End Date</h4>
              <v-date-picker
                full-width
                v-model="investigator.vacation.end_date"
                :locale="$store.state.language"
                :min="investigator.vacation.start_date"
                disabled
              />
            </v-col>
          </v-row>
          <v-divider />

          <DirectorActions v-if="isAuthorize" :object_type="object_type" />
          <SupervisorActions
            v-else
            :item="investigator"
            :object_type="object_type"
            :form_name="form_name"
            :state="state"
            :supervisor="supervisor !== null ? supervisor.username : ''"
            @change-state-supervisor="onStateSupervisorChange"
          />
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import RejectCommentLayout from "../../layouts/RejectCommentLayout";
import SupervisorActions from "../../action_buttons/SupervisorActions";
import DirectorActions from "../../action_buttons/DirectorActions";
import investigatorData from "../../../mixins/investigator_data";
import investigator_model from "../../../mixins/model_utils/investigator_model";

export default {
  mixins: [investigatorData, investigator_model],
  components: { RejectCommentLayout, SupervisorActions, DirectorActions },

  data: () => ({
    state: "",
    reject_comment: "",
    object_type: "",
    supervisor: "",
    title: "",
    form_name: "",
  }),

  created() {
    this.getVacations();
    this.getData();
  },

  computed: {
    isAuthorize() {
      return this.$route.meta.authorize !== undefined;
    },
    numberDays() {
      var startDate = new Date(this.investigator.vacation.start_date);
      var endDate = new Date(this.investigator.vacation.end_date);

      var numWorkDays = 0;
      while (startDate <= endDate) {
        if (startDate.getDay() !== 0 && startDate.getDay() !== 6) {
          numWorkDays++;
        }
        startDate.setDate(startDate.getDate() + 1);
      }
      return numWorkDays;
    }
  },

  methods: {
    getData() {
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/review/investigator/" +
        this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.investigator.vacation = response.data.data.user;
          this.reject_comment = response.data.reject_comment;
          this.form_name = response.data.form_name;
          this.title = response.data.title;
          this.state = response.data.state;
          this.supervisor = response.data.supervisor;
          this.object_type = response.data.object_type;
          this.investigator.id = response.data.object_id;
          this.getInvestigatorName(this.$store.state.endpoint + "/person/" + this.investigator.id);
        })
        .catch(error => {
          console.log(error);
        });
    },

    onStateSupervisorChange(state, supervisor){
      this.state = state;
      this.supervisor = supervisor;
    }
  }
};
</script>
